import axios from 'axios';
import { interceptorRequest, interceptorRequestError } from './interceptors/request';
import { interceptorResponse, interceptorResponseError, setStore, setRouter } from './interceptors/response';

const httpClient = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	timeout: 180000, // 3 mins
	headers: {
		'Content-Type': 'application/json',
		accept: 'application/json',
	},
	withCredentials: true,
});

export function initHttpClient(store, router) {
	setStore(store);
	setRouter(router);

	httpClient.interceptors.request.use(interceptorRequest, interceptorRequestError);
	httpClient.interceptors.response.use(interceptorResponse, interceptorResponseError);
}

export default httpClient;
